import { DOCUMENT } from "@angular/common";
import { Inject, Injectable } from "@angular/core";
import {
  FeatureManagerConfiguration,
  FeatureManagerConfigurationService,
} from "@cotecna/feature-manager";
import { CotecnaUserService } from "@cotecna/session";
import { environment } from "src/environments/environment";

import { UserService } from "./session/services/user.service";

@Injectable({
  providedIn: "root",
})
export class AppInitializer {
  constructor(
    private featureManagerConfigurationService: FeatureManagerConfigurationService,
    private cotecnaUserService: CotecnaUserService,
    private userService: UserService,
    @Inject(DOCUMENT) private document: Document,
  ) {}

  async init(): Promise<void> {
    this.configureFeatureManager();
    this.attachGooglePlacesToAddressDialog();
    await this.refreshUser();
  }

  private configureFeatureManager() {
    this.featureManagerConfigurationService.configure(
      <FeatureManagerConfiguration>environment.featureManager,
    );
  }

  private async refreshUser(): Promise<void> {
    const userIsLoggedIn = this.cotecnaUserService.isConnected();

    if (userIsLoggedIn) {
      await this.userService.setUser();
    }
  }

  private attachGooglePlacesToAddressDialog(): void {
    const moveAutocompletePopup = () => {
      const dialogWrapper = this.document.querySelector(
        ".cdk-global-overlay-wrapper:has(.address-dialog)",
      );
      const autocompletePopup = this.document.querySelector(".pac-container");

      if (dialogWrapper && autocompletePopup?.parentElement !== dialogWrapper) {
        dialogWrapper.appendChild(autocompletePopup);
      }
    };

    new MutationObserver(moveAutocompletePopup).observe(this.document.body, {
      childList: true,
      subtree: true,
    });
  }
}
